import { ICG2Guidelines } from '@fortem-monorepo/web-sdk'

type FormatOptions = {
  decimalPlaces?: number
  roundingMode?: 'round' | 'truncate'
  type?: ICG2Guidelines.ThresholdType
  suffix?: string
}

const defaultOptions: Required<FormatOptions> = {
  decimalPlaces: 2,
  roundingMode: 'round',
  type: 'unit',
  suffix: '',
}

/**
 * Assumes the value being passed in is already a number
 */
export const formatNumber = (_number: number | string | null | undefined, _options: FormatOptions = defaultOptions) => {
  let number = Number(_number)

  if (isNaN(number)) return ''

  const options = { ...defaultOptions, ..._options }

  if (options.roundingMode === 'truncate') {
    number = truncate(number, options.decimalPlaces)
  }

  const formatted = number.toLocaleString('en-GB', {
    minimumFractionDigits: options.decimalPlaces,
    maximumFractionDigits: options.decimalPlaces,
  })

  let result = formatted

  if (options.suffix) {
    result += options.suffix
  }

  return result
}

export const getNumberTypeSuffix = (type: ICG2Guidelines.ThresholdType) => {
  switch (type) {
    case 'percentage':
      return '%'
    case 'basis_points':
      return 'bps'
    case 'unit':
      return ''
  }
}

/**
 * Similar to specifying decimal places, but without rounding
 */
export const truncate = (value: number, decimalPlaces: number) => {
  const factor = 10 ** decimalPlaces
  return Math.trunc(value * factor) / factor
}

/**
 * Round a number specifying the decimal places
 */
export const round = (value: number, decimalPlaces: number = 2) => {
  return value.toLocaleString('en-GB', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })
}
